import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";
import styled from "styled-components";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    inner: {
      backgroundColor: theme.background,
      border: `1px solid ${theme.border}`,
      boxShadow: `0px 0px 15px  ${theme.border}`,
    },
  };

  return styles;
};

export const TabContainer = styled.div`
  position: fixed;
  display: flex;
  z-index: 999;
  width: 100vw;
  height: 88px;
  bottom: 16px;
  align-items: center;
  justify-content: center;
  padding: 0 ${spacing.m}px;
  box-sizing: border-box;
`;

export const TabContainerInner = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  justify-content: space-between;
  padding: ${constants.divPadding}px;
  border-radius: ${constants.radius.view}px;
  box-sizing: border-box;
`;

export const TabBarItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  cursor: pointer;
`;
